import { createElement } from 'react';
import type { FC } from 'react';
import DOMPurify from 'dompurify';

interface SafeHTMLProps {
  html: string;
  tag?: keyof JSX.IntrinsicElements;
  removeLayoutStyles?: boolean;
  [key: string]: any;
}

const SafeHTML: FC<SafeHTMLProps> = ({ html, tag = 'div', removeLayoutStyles = false, onClick, ...props }) => {
  let processedHTML = html;

  if (removeLayoutStyles) {
    processedHTML = html
      .replace(/text-align:\s*[^;]*;?/gi, '')
      .replace(/list-style:\s*[^;]*;?/gi, '')
      .replace(/style="[;\s]*"/gi, '')
      .replace(/<li><p[^>]*>/gi, '<li>')
      .replace(/<\/p><\/li>/gi, '</li>')
      .replace(/\s+/g, ' ')
      .trim();
  }

  // Replace href="#" with javascript:void(0) to prevent page scroll
  processedHTML = processedHTML.replace(/href=["']#["']/g, 'href="javascript:void(0)"');

  const cleanHTML = DOMPurify.sanitize(processedHTML, {
    ADD_TAGS: ['sup'],
    ADD_ATTR: ['target'],
  });

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    const target = e.target as HTMLElement;
    if (target.tagName === 'A') {
      const href = target.getAttribute('href');
      if (href === '#' || href === 'javascript:void(0)') {
        e.preventDefault();
        e.stopPropagation();
      }
    }
    if (onClick) {
      onClick(e);
    }
  };

  return createElement(tag, { dangerouslySetInnerHTML: { __html: cleanHTML }, onClick: handleClick, ...props });
};

export default SafeHTML;
